import React, { useEffect, useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// import { Star } from "lucide-react"; // outline star
import { motion } from "framer-motion";
import Lottie from "react-lottie";
import { useWindowSize } from "react-use";
import UserContext from "../../context/UserContext";
import * as diamondAnimation from "../../lottie/Diamond.json";
const Results2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useContext(UserContext);
  // const [attempt, setAttempt] = useState(null);
  const { score, total, book, gems, scorePercentage, tryAgain } = location.state || { score: 4, total: 5 };
  // const { score, total } = { score: 4, total: 5 };
  // const { score, total } = location.state || { score: 4, total: 5 };
  const [currentView, setCurrentView] = useState('stars'); // 'stars', 'emerald', 'book'

  // Debug logging
  console.log('Result2 - Received data:', { score, total, book, gems, scorePercentage, tryAgain });
  console.log('Result2 - Location state:', location.state);

  useEffect(() => {
    // Auto-advance through the views
    const timer1 = setTimeout(() => {
      setCurrentView('emerald');
    }, 3000);

    const timer2 = setTimeout(() => {
      // setCurrentView('book');
      setShowBook(true);
      // Delay emerald movement to bottom
      setTimeout(() => {
        setEmeraldAtBottom(true);
      }, 1000);
    }, 5000);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  const [showBook, setShowBook] = useState(false);
  const [emeraldAtBottom, setEmeraldAtBottom] = useState(false);


  const windowSize = useWindowSize();
  const totalStars = 5;

  // Animation for each filled star with a delay
  const celebrationVariants = (delay) => ({
    animate: {
      scale: [1, 1.4, 1],
      transition: {
        duration: 0.5,
        delay: delay,
        ease: "easeInOut",
        // repeat: 2,
        // repeatDelay: 0.1
      }
    }
  });

  // Emerald animation variants
  const emeraldVariants = {
    center: {
      scale: 1,
      x: 0,
      y: 0,
      zIndex: 20,
      transition: { duration: 1, ease: "easeInOut" }
    },
    bottom: {
      scale: 0.15, // Shrink to fit small emerald
      x: 0,
      y: 150, // Move to bottom center of book
      zIndex: 30,
      transition: { duration: 2, ease: "easeOut" }
    }
  };

  // Book cover animation variants
  const bookVariants = {
    hidden: {
      opacity: 0,
      scale: 3,
      y: 50
    },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: { duration: 1.5, ease: "easeIn" }
    }
  };

  // Text animation variants
  const textVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1, ease: "easeOut", delay: 1.5 }
    }
  };
  //  const totalStars = 5;

  // // Celebration animation for the last answered star
  // const celebrationVariants = {
  //   animate: {
  //     scale: [1, 1.3, 1, 1.3, 1],
  //     transition: {
  //       duration: 1.5,
  //       repeat: 2,
  //       ease: "easeInOut"
  //     }
  //   }
  // };

  const percentage = Math.round((score / total) * 100);
  const earnedStars = Math.floor((score / total) * 5);

  const getGemType = () => {
    if (gems && gems.name) {
      return gems.name; // 'emerald', 'sapphire', or 'ruby'
    }
    // Fallback to score-based logic if no gems info
    if (percentage >= 80) return 'emerald';
    if (percentage >= 60) return 'sapphire';
    return 'ruby';
  };

  const gemType = getGemType();

  console.log('Result2 - Gem type determined:', gemType);
  console.log('Result2 - Gems object:', gems);
  console.log('Result2 - Gems name:', gems?.name);

  const getGemColor = (type) => {
    switch (type) {
      case 'emerald': return '#27CA40';
      case 'sapphire': return '#4FC3F7';
      case 'ruby': return '#e12b21ff';
      default: return '#27CA40';
    }
  };

  const gemColor = getGemColor(gemType);
  console.log('Result2 - Gem color:', gemColor);

  // Check if we should show the tryAgain result page
  const shouldShowTryAgainPage = tryAgain && tryAgain.available === false;
  console.log('Result2 - Should show tryAgain page:', shouldShowTryAgainPage);

  // TryAgain Result Page - when available is false
  if (shouldShowTryAgainPage) {
    return (
      <div className="h-screen bg-[#3D74B6] relative overflow-hidden">
        {/* Header */}
        <header className="bg-[#3D74B6] shadow-lg">
          <div className="px-10 py-4">
            <h1 className="text-4xl font-['Cheese_Matcha'] text-[#FBF5DE] text-center">
              Quiz Complete
            </h1>
          </div>
        </header>

        {/* Main Content */}
        <main className="h-full px-2 py-2">
          <div className="h-full max-w-8xl mx-auto">
            <div className="h-[86%] bg-white rounded-[30px] text-center relative overflow-hidden flex flex-col items-center justify-center">
              {/* Background with children image */}
              <div
                className="absolute inset-0 opacity-20"
                style={{
                  backgroundImage: `url("${location.state?.book?.book.coverImage}")`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}
              />

              <div className="relative z-10 flex flex-col items-center justify-center space-y-8">
                {/* Result Message */}
                <div className="space-y-4">
                  <h1 className="text-6xl font-['Cheese_Matcha'] text-[#374957] mb-4">
                    Great effort, {user.firstName}!
                  </h1>
                  <div className="text-4xl font-['Cheese_Matcha'] text-[#3D74B6] font-bold">
                    You got {score}/{total} correct!
                  </div>
                </div>

                {/* Try Again Information */}
                <div className="bg-[#F2F2F2] rounded-[20px] p-8 max-w-2xl">
                  <div className="space-y-4">
                    <h2 className="text-3xl font-['Cheese_Matcha'] text-[#374957] mb-4">
                      Try Again Information
                    </h2>
                    <div className="space-y-2 text-xl font-['KG_Primary_Penmanship'] text-[#374957]">
                      <p>Attempts used: <span className="font-bold">{tryAgain.attemptsUsed}</span></p>
                      <p>Max attempts: <span className="font-bold">{tryAgain.maxAttempts}</span></p>
                      <p>Remaining attempts: <span className="font-bold text-[#FF6058]">{tryAgain.remainingAttempts}</span></p>
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-4">
                  <button
                    onClick={() => navigate('/library')}
                    className="flex items-center justify-center gap-4 px-8 py-4 bg-[#49A2F5] text-white rounded-full text-2xl font-medium shadow-lg hover:shadow-xl transition-all transform hover:scale-105"
                  >
                    <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_473_1539)">
                        <path d="M28.25 2.70358C27.5374 2.10903 26.7014 1.68064 25.8026 1.4495C24.9038 1.21837 23.9648 1.1903 23.0537 1.36733L20.8487 1.90733C19.698 2.1182 18.6577 2.72587 17.9088 3.62461C17.1599 4.52334 16.7498 5.65622 16.75 6.82608V26.1598C15.9211 26.2811 15.0789 26.2811 14.25 26.1598V6.82608C14.2541 5.667 13.8536 4.54284 13.1174 3.64758C12.3812 2.75233 11.3555 2.14214 10.2175 1.92233L7.875 1.35233C6.97395 1.18745 6.04766 1.22264 5.16172 1.45542C4.27578 1.6882 3.45183 2.11288 2.74821 2.6994C2.04458 3.28591 1.47848 4.01992 1.08998 4.84946C0.701473 5.67901 0.500061 6.58381 0.5 7.49983L0.5 20.9911C0.500072 22.4546 1.01372 23.8716 1.95142 24.9953C2.88911 26.1189 4.19139 26.8779 5.63125 27.1398L13.4887 28.5686C14.8187 28.8102 16.1813 28.8102 17.5112 28.5686L25.375 27.1398C26.8137 26.8766 28.1145 26.1171 29.051 24.9935C29.9874 23.87 30.5002 22.4537 30.5 20.9911V7.49983C30.5006 6.58413 30.2992 5.67958 29.9103 4.85057C29.5214 4.02156 28.9545 3.2885 28.25 2.70358Z" fill="#374957" />
                      </g>
                      <defs>
                        <clipPath id="clip0_473_1539">
                          <rect width="30" height="30" fill="white" transform="translate(0.5)" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span>Back to Library</span>
                  </button>

                  <button
                    onClick={() => window.location.reload()}
                    className="flex items-center justify-center gap-4 px-8 py-4 bg-[#B4E50D] text-[#374957] rounded-full text-2xl font-medium shadow-lg hover:shadow-xl transition-all transform hover:scale-105"
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 4V1L1 4L4 7V4ZM20 4V7L23 4L20 1V4ZM4 10H20V14H4V10ZM4 16H20V20H4V16Z" fill="currentColor" />
                    </svg>
                    <span>Try Again</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }

  // Star Results View
  if (currentView === 'stars') {
    return (
      <div className="h-screen bg-[#3D74B6] relative overflow-hidden">
        {/* Header */}
        <header className="bg-[#3D74B6] shadow-lg">
          <div className="px-10 py-4">
            <h1 className="text-4xl font-['Cheese_Matcha'] text-[#FBF5DE] text-center">
              Doing Your Best
            </h1>
          </div>
        </header>

        {/* Main Content */}
        <main className="h-full px-2 py-2">
          <div className="h-full max-w-8xl mx-auto">
            <div className="h-[86%] bg-white rounded-[30px] text-center relative overflow-hidden">
              {/* Background with children image */}
              <div
                className="absolute inset-0 opacity-20"
                style={{
                  backgroundImage: 'url("/images/imagebook.png")',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}
              ></div>

              <div className="relative z-10">
                {/* Congratulations Message */}
                <h1 className="text-7xl font-['Cheese_Matcha'] text-[#374957] mb-16 italic">
                  Well done, {user.firstName}!
                </h1>

                {/* Star Rating */}
                {/* <div className="flex justify-center gap-4 mb-16">
                  {[...Array(5)].map((_, index) => (
                    <div 
                      key={index}
                      className="w-20 h-20"
                    >
                      <svg viewBox="0 0 100 100" className="w-full h-full">
                        <path 
                          d="M50 10L61 35L90 35L68 53L79 85L50 70L21 85L32 53L10 35L39 35L50 10Z" 
                          fill={index < earnedStars ? "#FFD700" : "none"}
                          stroke="#FFD700" 
                          strokeWidth="3"
                        />
                      </svg>
                    </div>
                  ))}
                </div> */}

                <div className="flex items-center justify-center">
                  <div className="flex gap-4">
                    {/* {Array.from({ length: totalStars }).map((_, index) => {
          const isFilled = index < score;
          const isCelebrated = score >= 3 && score <= 4 && index === score - 1;

          if (isCelebrated) {
            return (
              <motion.div
                key={index}
                variants={celebrationVariants}
                animate="animate"
                className="text-yellow-500"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="w-12 h-12"
                >
                  <path d="M12 .587l3.668 7.568L24 9.75l-6 5.847 1.416 8.264L12 19.896l-7.416 3.965L6 15.597 0 9.75l8.332-1.595z" />
                </svg>
              </motion.div>
            );
          }

          return (
            <div
              key={index}
              className={`w-12 h-12 ${
                isFilled ? "text-yellow-500" : "text-gray-300"
              }`}
            >
              {isFilled ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="w-12 h-12"
                >
                  <path d="M12 .587l3.668 7.568L24 9.75l-6 5.847 1.416 8.264L12 19.896l-7.416 3.965L6 15.597 0 9.75l8.332-1.595z" />
                </svg>
              ) : (
                 <svg viewBox="0 0 100 100" className="w-full h-full">
                        <path 
                          d="M50 10L61 35L90 35L68 53L79 85L50 70L21 85L32 53L10 35L39 35L50 10Z" 
                          fill={index < earnedStars ? "#FFD700" : "none"}
                          stroke="#FFD700" 
                          strokeWidth="3"
                        />
                      </svg>
                // <Star className="w-12 h-12" strokeWidth={2} />
              )}
            </div>
          );
        })} */}
                    {Array.from({ length: totalStars }).map((_, index) => {
                      const isFilled = index < score;

                      if (isFilled) {
                        return (
                          <motion.div
                            key={index}
                            variants={celebrationVariants(index * 0.3)}
                            animate="animate"
                            className="w-25 h-25 text-yellow-500"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              className="w-full h-full"
                            >
                              <path d="M12 .587l3.668 7.568L24 9.75l-6 5.847 1.416 8.264L12 19.896l-7.416 3.965L6 15.597 0 9.75l8.332-1.595z" />
                            </svg>
                          </motion.div>
                        );
                      }

                      return (
                        <div key={index} className="text-gray-300 flex items-center justify-center">
                          <div
                            key={index}
                            className={`aspect-square 
        w-20 sm:w-40 md:w-50 lg:w-60  ${isFilled ? "text-yellow-500" : "text-gray-300"
                              }`}
                          >
                            {isFilled ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                className="w-full h-full"
                              >
                                <path d="M12 .587l3.668 7.568L24 9.75l-6 5.847 1.416 8.264L12 19.896l-7.416 3.965L6 15.597 0 9.75l8.332-1.595z" />
                              </svg>
                            ) : (
                              <svg viewBox="0 0 100 100" className="w-full h-full">
                                <path
                                  d="M50 10L61 35L90 35L68 53L79 85L50 70L21 85L32 53L10 35L39 35L50 10Z"
                                  fill={index < earnedStars ? "#FFD700" : "none"}
                                  stroke="#FFD700"
                                  strokeWidth="3"
                                />
                              </svg>
                              // <Star className="w-12 h-12" strokeWidth={2} />
                            )}
                          </div>
                          {/* <Star className="w-12 h-12" strokeWidth={2} /> */}
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Score Display */}
                <div className="text-center space-y-4">
                  <div className="flex items-center justify-center gap-6">
                    <span className="text-5xl font-['Cheese_Matcha'] text-[#374957]">You got</span>
                    <span className="text-8xl font-['Cheese_Matcha'] text-[#3D74B6] font-bold">
                      {String(score).padStart(2, '0')}/{String(total).padStart(2, '0')}
                    </span>
                    <span className="text-5xl font-['Cheese_Matcha'] text-[#374957]">Correct!</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }

  // Emerald Achievement View
  // if (currentView === 'emerald') {
  //   return (
  //     <div className="h-screen bg-[#3D74B6] relative overflow-hidden">
  //       {/* Header */}
  //       <header className="bg-[#3D74B6] shadow-lg">
  //         <div className="px-10 py-4">
  //           <h1 className="text-4xl font-['Cheese_Matcha'] text-[#FBF5DE] text-center">
  //             Doing Your Best
  //           </h1>
  //         </div>
  //       </header>

  //       {/* Main Content */}
  //       <main className="h-full px-12 py-12">
  //         <div className="h-full max-w-8xl mx-auto">
  //           <div className="h-[86%] bg-white rounded-[30px] p-16 text-center relative overflow-hidden min-h-[600px] flex items-center justify-center">
  //             {/* Emerald Background Glow */}
  //             <div className="absolute inset-0 bg-gradient-radial from-green-200/30 via-green-100/20 to-transparent"></div>


  //           </div>
  //         </div>
  //       </main>
  //     </div>
  //   );
  // }


  // Combined Emerald and Book view
  return (
    <div className="h-screen bg-[#3D74B6] relative overflow-hidden">
      {/* Header */}
      <header className="bg-[#3D74B6] shadow-lg">
        <div className="px-10 py-4">
          <h1 className="text-4xl font-['Cheese_Matcha'] text-[#FBF5DE] text-center">
            Doing Your Best
          </h1>
        </div>
      </header>

      {/* Main Content */}
      <main className="h-full px-2 py-2">
        <div className="h-full max-w-8xl mx-auto">
          <div className="h-[86%] bg-white rounded-[30px] p-16 text-center relative overflow-hidden">

            {/* Background with children image */}
            <div
              className="absolute inset-0 opacity-20"
              style={{
                backgroundImage: `url("${location.state?.book?.book.coverImage}")`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            />

            {/* White Glow Background - only when emerald is center */}
            {!showBook && (
              <div
                className="absolute inset-0 flex items-center justify-center pointer-events-none"
                style={{
                  zIndex: 0,
                  filter: "blur(32px)",
                }}
              >


                {/* <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: [0, 1, 0.8, 1] }}
                  transition={{ duration: 2, ease: "easeInOut", repeat: Infinity, repeatType: "reverse" }}
                  style={{
                    width: windowSize.width > 900 ? 600 : 400,
                    height: windowSize.width > 900 ? 600 : 400,
                    borderRadius: "50%",
                    background: "radial-gradient(circle, #fff 40%, transparent 80%)",
                    boxShadow: "0 0 120px 60px #fff, 0 0 200px 120px #ffffff80",
                  }}
                /> */}
              </div>
            )}

            <div className="relative z-10 flex items-center justify-center">

              {/* Book Cover Display */}
              <motion.div
                variants={bookVariants}
                initial="hidden"
                animate={showBook ? "visible" : "hidden"}
                className="relative"
              >
                {/* Book Cover */}
                <div
                  className="w-80 h-96 rounded-lg shadow-2xl border-4 border-gray-800 relative overflow-hidden"
                  style={{
                    backgroundImage: `url("${location.state?.book.book?.coverImage}")`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}
                >

                  {/* Book title overlay */}
                  <motion.div
                    variants={textVariants}
                    initial="hidden"
                    animate={showBook ? "visible" : "hidden"}
                    className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4"
                  >
                    <div className="text-white text-end">
                      <div className="text-lg font-['Sriracha'] transform -rotate-6 mb-2">Read by</div>
                      <div className="text-3xl font-['Sriracha'] transform -rotate-6 font-bold">{user.firstName}</div>
                    </div>
                  </motion.div>
                </div>
              </motion.div>

              <motion.div
                // wrapper animates position & scale for both glow and emerald so they stay synced
                variants={{
                  center: { x: 0, y: 0, scale: 1, transition: { duration: 1, ease: 'easeInOut' } },
                  bottom: { x: 0, y: 150, scale: 0.15, transition: { duration: 2, ease: 'easeOut' } },
                }}
                initial="center"
                animate={emeraldAtBottom ? 'bottom' : 'center'}
                className="absolute inset-0 flex items-center justify-center pointer-events-none"
                style={{ zIndex: 20 }}
              >
                {/* Glow (bigger than the emerald so it remains visible) */}
                <motion.div
                  initial={false}
                  animate={
                    emeraldAtBottom
                      ? {
                        opacity: 0.55,
                        scale: 2,
                        // smaller, tighter shadow when small
                        boxShadow: "0 0 60px 20px rgba(255,255,255,0.7)",
                      }
                      : {
                        opacity: 1,
                        scale: 1,
                        // strong large glow when centered
                        boxShadow:
                          "0 0 400px 180px rgba(255,255,255,0.98), 0 0 600px 300px rgba(255,255,255,0.6)",
                      }
                  }
                  transition={{ duration: 1.2, ease: 'easeInOut' }}
                  style={{
                    position: 'absolute',
                    width: windowSize.width > 900 ? (emeraldAtBottom ? 220 : 1200) : (emeraldAtBottom ? 160 : 900),
                    height: windowSize.width > 900 ? (emeraldAtBottom ? 220 : 1200) : (emeraldAtBottom ? 160 : 900),
                    borderRadius: '50%',
                    background: emeraldAtBottom
                      ? "radial-gradient(circle, rgba(255,255,255,0.95) 40%, transparent 70%)"
                      : "radial-gradient(circle, rgba(255,255,255,1) 30%, rgba(255,255,255,0.75) 55%, transparent 75%)",
                    // boxShadow: '0 0 400px 180px rgba(255,255,255,0.98), 0 0 600px 300px rgba(255,255,255,0.6)',
                    filter: emeraldAtBottom ? 'blur(18px)' : 'blur(72px)',
                    transformOrigin: 'center',
                    mixBlendMode: 'screen',
                    zIndex: 0
                  }}
                />

                {/* Gem Lottie on top (will follow wrapper transforms) */}
                <div style={{ zIndex: 10, pointerEvents: 'none' }}>
                  <Lottie
                    loop={true}
                    options={{
                      loop: true,
                      autoplay: true,
                      animationData: diamondAnimation,
                    }}
                    width={windowSize.width > 900 ? 800 : 600}
                    height={windowSize.width > 900 ? 800 : 600}
                    style={{ filter: `hue-rotate(${gemType === 'sapphire' ? '180deg' : gemType === 'ruby' ? '300deg' : '0deg'})` }}
                  />
                </div>
              </motion.div>

              {/* Action Button */}
            </div>
            <motion.button
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 3.5, duration: 1 }}
              onClick={() => navigate('/library')}
              className="relative flex items-center justify-center z-10 gap-4 mt-4 mx-auto px-12 py-6 bg-[#49A2F5] text-white rounded-full text-3xl font-medium shadow-lg hover:shadow-xl transition-all transform hover:scale-105"
            >
              <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_473_1539)">
                  <path d="M28.25 2.70358C27.5374 2.10903 26.7014 1.68064 25.8026 1.4495C24.9038 1.21837 23.9648 1.1903 23.0537 1.36733L20.8487 1.90733C19.698 2.1182 18.6577 2.72587 17.9088 3.62461C17.1599 4.52334 16.7498 5.65622 16.75 6.82608V26.1598C15.9211 26.2811 15.0789 26.2811 14.25 26.1598V6.82608C14.2541 5.667 13.8536 4.54284 13.1174 3.64758C12.3812 2.75233 11.3555 2.14214 10.2175 1.92233L7.875 1.35233C6.97395 1.18745 6.04766 1.22264 5.16172 1.45542C4.27578 1.6882 3.45183 2.11288 2.74821 2.6994C2.04458 3.28591 1.47848 4.01992 1.08998 4.84946C0.701473 5.67901 0.500061 6.58381 0.5 7.49983L0.5 20.9911C0.500072 22.4546 1.01372 23.8716 1.95142 24.9953C2.88911 26.1189 4.19139 26.8779 5.63125 27.1398L13.4887 28.5686C14.8187 28.8102 16.1813 28.8102 17.5112 28.5686L25.375 27.1398C26.8137 26.8766 28.1145 26.1171 29.051 24.9935C29.9874 23.87 30.5002 22.4537 30.5 20.9911V7.49983C30.5006 6.58413 30.2992 5.67958 29.9103 4.85057C29.5214 4.02156 28.9545 3.2885 28.25 2.70358Z" fill="#374957" />
                </g>
                <defs>
                  <clipPath id="clip0_473_1539">
                    <rect width="30" height="30" fill="white" transform="translate(0.5)" />
                  </clipPath>
                </defs>
              </svg>
              <span>Go to Library</span>
            </motion.button>
          </div>
        </div>
      </main>
    </div>
  );
};



// Book Achievement View
//   return (
//     <div className="h-screen bg-[#3D74B6] relative overflow-hidden">
//       {/* Header */}
//       <header className="bg-[#3D74B6] shadow-lg">
//         <div className="px-10 py-4">
//           <h1 className="text-4xl font-['Cheese_Matcha'] text-[#FBF5DE] text-center">
//             Doing Your Best
//           </h1>
//         </div>
//       </header>

//       {/* Main Content */}
//       <main className="h-full px-2 py-2">
//         <div className="h-full max-w-8xl mx-auto">
//           <div className="h-[86%] bg-white rounded-[30px] p-16 text-center relative overflow-hidden">
//             {/* Background with children image */}
//             <div
//               className="absolute inset-0 opacity-20"
//               style={{
//                 backgroundImage: 'url("/images/imagebook.png")',
//                 backgroundSize: 'cover',
//                 backgroundPosition: 'center'
//               }}
//             ></div>

//             {currentView === 'emerald' && (
//               <div className="relative z-10 flex items-center justify-center">
//                 {/* Emerald Glow Background */}
//                 <div
//                   className="absolute inset-0 flex items-center justify-center pointer-events-none"
//                   style={{
//                     zIndex: 0,
//                     filter: "blur(32px)",
//                   }}
//                 >
//                   <div
//                     style={{
//                       width: windowSize.width > 900 ? 600 : 400,
//                       height: windowSize.width > 900 ? 600 : 400,
//                       borderRadius: "50%",
//                       background: "radial-gradient(circle, #fff 40%, transparent 80%)",
//                       boxShadow: "0 0 120px 60px #fff, 0 0 200px 120px #ffffff80",
//                     }}
//                   />
//                 </div>
//                 {/* Large Emerald Display */}
//                 <motion.div
//                   initial={{ scale: 0.9, boxShadow: "0 0 0px #27CA40" }}
//                   animate={{ scale: [1, 1.15, 1], boxShadow: ["0 0 40px #27CA40", "0 0 80px #27CA40", "0 0 40px #27CA40"] }}
//                   transition={{ duration: 2, ease: "easeInOut", repeat: Infinity, repeatType: "reverse" }}
//                   className="emerald-shadow animate-pulse justify-center items-center flex"
//                 >
//                   {/* <div className="emerald-shadow animate-pulse justify-center items-center"> */}
//                   <Lottie
//                     loop={true}
//                     options={{
//                       loop: true,
//                       autoplay: true,
//                       animationData: diamondAnimation,
//                     }}
//                     width={(windowSize.width > 900) ? 800 : 600}
//                     height={(windowSize.width > 900) ? 800 : 600}
//                   />
//                   {/* <svg viewBox="0 0 200 200" className="w-full h-full"> */}
//                   {/* Main emerald body */}
//                   {/* <path d="M100 20L160 50L145 150L55 150L40 50L100 20Z" fill="#27CA40"/> */}
//                   {/* Top facets */}
//                   {/* <path d="M100 20L130 35L160 50L130 65L100 50L70 65L40 50L70 35L100 20Z" fill="#2EE649" opacity="0.8"/> */}
//                   {/* Left facet */}
//                   {/* <path d="M40 50L70 65L100 80L70 100L40 150L25 110L40 50Z" fill="#1FA832" opacity="0.9"/> */}
//                   {/* Right facet */}
//                   {/* <path d="M160 50L130 65L100 80L130 100L160 150L175 110L160 50Z" fill="#1FA832" opacity="0.9"/> */}
//                   {/* Center highlight */}
//                   {/* <path d="M100 50L130 65L100 80L70 65L100 50Z" fill="#5FFF7A" opacity="0.6"/> */}
//                   {/* </svg> */}
//                   {/* </div> */}
//                 </motion.div>
//               </div>)

//             }
//             {currentView === 'book'&& (
//             <div className="relative z-10">
//               {/* Achievement Message */}
//               {/* <div className="mb-8">
//                 <h1 className="text-6xl font-['Sriracha'] text-[#374957] mb-4">
//                   Well done, <span className="text-[#3D74B6]">Mark!</span>
//                 </h1>
//                 <div className="flex items-center justify-center gap-4 mb-8">
//                   <span className="text-4xl font-['Sriracha'] text-[#374957]">You earned an</span>
//                   <span className="text-6xl font-['Sriracha'] text-[#27CA40] font-bold">Emerald</span>
//                 </div>
//               </div> */}

//               {/* Book Cover Display */}
//               <div className="flex justify-center mb-8">
//                 <motion.div
//                   initial={{ opacity: 1, scale: 1 }}
//                   animate={{ opacity: 0, scale: 0.8 }}
//                   transition={{ duration: 1.2, ease: "easeOut" }}
//                   className="relative"
//                 >
//                   {/* <div className="relative"> */}
//                   {/* Book Cover */}
//                   <div
//                     className="w-80 h-96 rounded-lg shadow-2xl border-4 border-gray-800 relative overflow-hidden"
//                     style={{
//                       backgroundImage: 'url("/images/image.png")',
//                       backgroundSize: 'cover',
//                       backgroundPosition: 'center'
//                     }}
//                   >
//                     {/* Book title overlay */}
//                     <motion.div
//                       initial={{ opacity: 1, y: 0 }}
//                       animate={{ opacity: 0, y: 40 }}
//                       transition={{ duration: 1.2, ease: "easeOut" }}
//                       className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4"
//                     >
//                       {/* <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4"> */}
//                       <div className="text-white text-center">
//                         <div className="text-lg font-['Sriracha'] transform -rotate-6 mb-2">Read by</div>
//                         <div className="text-3xl font-['Sriracha'] transform -rotate-6 font-bold">Mark</div>
//                       </div>
//                       {/* </div> */}
//                     </motion.div>
//                     {/* Emerald gem at bottom */}
//                     <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2">
//                       <div className="w-16 h-16 emerald-shadow">
//                         <Lottie
//                           loop={true}
//                           options={{
//                             loop: true,
//                             autoplay: true,
//                             animationData: diamondAnimation,
//                           }}
//                           width={(windowSize.width > 900) ? 80 : 60}
//                           height={(windowSize.width > 900) ? 80 : 60}
//                         />
//                         {/* <svg viewBox="0 0 60 60" className="w-full h-full">
//                           <path d="M30 5L50 15L45 45L15 45L10 15L30 5Z" fill="#27CA40"/>
//                           <path d="M30 5L40 12L45 15L38 20L30 15L22 20L15 15L20 12L30 5Z" fill="#2EE649" opacity="0.8"/>
//                         </svg> */}
//                       </div>
//                     </div>
//                   </div>
//                   {/* </div> */}
//                 </motion.div>
//               </div>

//               {/* Action Button */}
//               <button
//                 onClick={() => navigate('/library')}
//                 className="flex items-center justify-center gap-4 mx-auto px-12 py-6 bg-[#49A2F5] text-white rounded-full text-3xl font-medium shadow-lg hover:shadow-xl transition-all transform hover:scale-105"
//               >
//                 <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
//                   <g clip-path="url(#clip0_473_1539)">
//                     <path d="M28.25 2.70358C27.5374 2.10903 26.7014 1.68064 25.8026 1.4495C24.9038 1.21837 23.9648 1.1903 23.0537 1.36733L20.8487 1.90733C19.698 2.1182 18.6577 2.72587 17.9088 3.62461C17.1599 4.52334 16.7498 5.65622 16.75 6.82608V26.1598C15.9211 26.2811 15.0789 26.2811 14.25 26.1598V6.82608C14.2541 5.667 13.8536 4.54284 13.1174 3.64758C12.3812 2.75233 11.3555 2.14214 10.2175 1.92233L7.875 1.35233C6.97395 1.18745 6.04766 1.22264 5.16172 1.45542C4.27578 1.6882 3.45183 2.11288 2.74821 2.6994C2.04458 3.28591 1.47848 4.01992 1.08998 4.84946C0.701473 5.67901 0.500061 6.58381 0.5 7.49983L0.5 20.9911C0.500072 22.4546 1.01372 23.8716 1.95142 24.9953C2.88911 26.1189 4.19139 26.8779 5.63125 27.1398L13.4887 28.5686C14.8187 28.8102 16.1813 28.8102 17.5112 28.5686L25.375 27.1398C26.8137 26.8766 28.1145 26.1171 29.051 24.9935C29.9874 23.87 30.5002 22.4537 30.5 20.9911V7.49983C30.5006 6.58413 30.2992 5.67958 29.9103 4.85057C29.5214 4.02156 28.9545 3.2885 28.25 2.70358Z" fill="#374957" />
//                   </g>
//                   <defs>
//                     <clipPath id="clip0_473_1539">
//                       <rect width="30" height="30" fill="white" transform="translate(0.5)" />
//                     </clipPath>
//                   </defs>
//                 </svg>

//                 {/* <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
//                   <path fillRule="evenodd" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" clipRule="evenodd" />
//                 </svg> */}
//                 <span>Go to Library</span>
//               </button>
//             </div>)}
//           </div>
//         </div>
//       </main>
//     </div>
//   );
// };

export default Results2;